import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getStudentNavSections } from '../components/Sidebar/roleNavConfig';
import { buildDomainSections } from '../components/Sidebar/buildDomainSections';
import StudentAssessmentResumeBar from '../components/student-home/StudentAssessmentResumeBar';
import useStudentEligibility from '../hooks/useStudentEligibility';

const StudentLayout = () => {
  const eligibility = useStudentEligibility();
  const baseNavSections = useMemo(
    () => getStudentNavSections(eligibility),
    [eligibility],
  );
  const sections = useMemo(
    () => buildDomainSections(baseNavSections, 'student'),
    [baseNavSections],
  );
  const shell = useMemo(
    () => ({
      homePath: '/student/home',
      workspacePath: '/student/dashboard',
      profilePath: '/student/profile',
      projectBasePath: '/student/project',
      codingRoot: null,
      codingActivityPath: null,
    }),
    [],
  );

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath="/student/home" sections={sections} contentMaxWidth={false}>
        <StudentAssessmentResumeBar />
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default StudentLayout;
